import { isMobilePlatform } from "./passkeys";

export const APP_LOCK_TIMEOUT_MS = 5 * 60_000;
const APP_LOCK_STORAGE_KEY = "ja:mobile-app-lock";

export type AppLockRecord = {
  userId: string;
  accountEmail?: string;
  lastActiveAt: number;
  locked: boolean;
  requireOnLaunch: boolean;
};

export function isInstalledPwa() {
  return Boolean(window.matchMedia?.("(display-mode: standalone), (display-mode: fullscreen)").matches)
    || Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
}

export function mobileAppLockEnabled() {
  return isInstalledPwa() && isMobilePlatform();
}

export function readAppLockRecord(): AppLockRecord | null {
  try {
    const value = JSON.parse(localStorage.getItem(APP_LOCK_STORAGE_KEY) ?? "null") as Partial<AppLockRecord> | null;
    if (!value || typeof value.userId !== "string" || typeof value.lastActiveAt !== "number") return null;
    return {
      userId: value.userId,
      ...(typeof value.accountEmail === "string" && value.accountEmail ? { accountEmail: value.accountEmail } : {}),
      lastActiveAt: value.lastActiveAt,
      locked: value.locked === true,
      requireOnLaunch: value.requireOnLaunch === true,
    };
  } catch {
    return null;
  }
}

export function writeAppLockRecord(record: AppLockRecord) {
  localStorage.setItem(APP_LOCK_STORAGE_KEY, JSON.stringify(record));
}

export function clearAppLockRecord() {
  localStorage.removeItem(APP_LOCK_STORAGE_KEY);
}

export function appLockRequired(record: AppLockRecord | null, userId: string, now = Date.now()) {
  if (!record || record.userId !== userId) return false;
  return record.locked || record.requireOnLaunch || now - record.lastActiveAt >= APP_LOCK_TIMEOUT_MS;
}
